import { signUpUrl } from '../../../Container/App'
import Index from '../../../Assets/Images/Index'
import Slider from 'react-slick'
import Fade from 'react-reveal/Fade';

const PrevArrow = ({ onClick }) => {
    return (
        <button className="quote-arrow quote-prev" onClick={onClick} type="button" aria-label="Previous"><img src={Index.prevArrow} alt="" /></button>
    );
};

const NextArrow = ({ onClick }) => {
    return (
        <button className="quote-arrow quote-next" onClick={onClick} type="button" aria-label="Next"><img src={Index.nextArrow} alt="" /></button>
    );
};

var settings = {
    arrows: true,
    centerMode: true,
    centerPadding: '400px',
    slidesToShow: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                centerPadding: '250px'
            }
        },
        {
            breakpoint: 1299,
            settings: {
                centerPadding: '180px'
            }
        },
        {
            breakpoint: 768,
            settings: {
                centerPadding: '120px'
            }
        },
        {
            breakpoint: 575,
            settings: {
                centerPadding: '0px'
            }
        }
    ]
};


export default function Manage() {
    return (
        <main>
            <section className="banner commonPY" style={{ backgroundImage: `url(${Index.headerbanner3New})` }}>
                <div className="container z-index">
                    <div className="row">
                        <Fade up>
                            <div className="col-md-5">
                                <div className="bannerContent">
                                    <div className="subTitle">
                                        <h5>Expand Your Business With a Powerful</h5>
                                    </div>
                                    <h1>Ecommerce Marketplace</h1>
                                    <p>Single point management for various business operations with Shopyxa. Make your ecommerce store management simpler and more cost-efficient.</p>
                                    <div className="buttonOuter">
                                        <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                                    </div>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </section>

            <section className="contentBlock commonPY">
                <div className="container">
                    <div className="contentBlockInner">
                        <div className="row">
                            <Fade up>
                                <div className="col-lg-6 parallax delay-2">
                                    <div className="contentBlockImage">
                                        <img src={Index.managecontentBlock1} alt="" />
                                    </div>
                                </div>
                            </Fade>
                            <Fade up>
                                <div className="col-lg-6 parallax delay-4">
                                    <div className="contentBlockContent">
                                        <h3>Fulfilling Order Management From Your Mobile</h3>
                                        <p>Control your orders, shipping details, and sales from a single dashboard. Shopyxa allows you to complete complex and time-consuming activities with less effort.</p>
                                        <div className="buttonOuter mt-0">
                                            <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div className="contentBlockInner">
                        <div className="row">
                            <Fade up>
                                <div className="col-lg-6 parallax delay-2">
                                    <div className="contentBlockImage">
                                        <img src={Index.managecontentBlock2} alt="" />
                                    </div>
                                </div>
                            </Fade>
                            <Fade up>
                                <div className="col-lg-6 parallax delay-4">
                                    <div className="contentBlockContent">
                                        <h3>Secure Payment Management</h3>
                                        <p>Get instant payments from your customers. They can pay with a few taps on the screen. Your customers can easily make payments with Shopyxa. Get on-the-spot notifications for the received amount.</p>
                                        <div className="buttonOuter mt-0">
                                            <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div className="contentBlockInner">
                        <div className="row">
                            <Fade up>
                                <div className="col-lg-6 parallax delay-2">
                                    <div className="contentBlockImage">
                                        <img src={Index.managecontentBlock3} alt="" />
                                    </div>
                                </div>
                            </Fade>
                            <Fade up>
                                <div className="col-lg-6 parallax delay-4">
                                    <div className="contentBlockContent">
                                        <h3>Get Automated: All-in-One Solution</h3>
                                        <p>Want to easily handle the inventory, payments, and orders in one go? If you are looking for websites like Shopify, then Shopyxa is one of the perfect Shopify alternatives.</p>
                                        <div className="buttonOuter mt-0">
                                            <a className="commonButton primary" href={signUpUrl}>Start Free Trial</a>
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                </div>
            </section>

            <section className="quote commonPY">
                <div className="container">
                    <Fade up>
                        <div className="headingText mb-5">
                            <h2>Meet the merchants who love <span>Shopyxa</span></h2>
                        </div>
                    </Fade>
                </div>
                <div className="quoteSlider">
                    <Slider {...settings}>
                        <div className="item">
                            <div className="quoteSlider__quote">
                                <div className="quoteIcon"><img src={Index.quoteIcon} alt="" /></div>
                                <div className="quoteContent">
                                    <div className="avatar"><img src={Index.kavitaKausal} alt="" /></div>
                                    <h4>Kavita Kausal</h4>
                                    <h6>CEO</h6>
                                    <p>I've found Shopyxa to be the best alternative for an e-commerce store-building platform. My brand is recognized nationwide now! All thanks to Shopyxa, which has the best potential for displaying my products online at a low cost.</p>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="quoteSlider__quote">
                                <div className="quoteIcon"><img src={Index.quoteIcon} alt="" /></div>
                                <div className="quoteContent">
                                    <div className="avatar"><img src={Index.pawasMahajan} alt="" /></div>
                                    <h4>Pawas Mahajan</h4>
                                    <h6>CEO</h6>
                                    <p>I started with their 15 days free trial, was impressed with their Shopyxa platform, and decided to maintain a long-term relationship with them to enjoy their services and improve my store.</p>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="quoteSlider__quote">
                                <div className="quoteIcon"><img src={Index.quoteIcon} alt="" /></div>
                                <div className="quoteContent">
                                    <div className="avatar"><img src={Index.judieLastina} alt="" /></div>
                                    <h4>Judie Lastina</h4>
                                    <h6>CEO</h6>
                                    <p>With my Shopyxa store, I am able to reach my target customers across all of India. I can get deep insights into the data and observe my audience's behavior, which helps me grow further. You should definitely try this platform if you are looking for high-class services on a low budget.</p>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </section>

            <section className="cta commonPB">
                <div className="container">
                    <Fade up>
                        <div className="ctaInner">
                            <div className="headingText white parallax delay-1">
                                <h5>Confused! How to make an online store.</h5>
                                <h2>Subscribe to Shopyxa and start your e-commerce journey?</h2>
                            </div>
                            <div className="buttonOuter parallax delay-3">
                                <a className="commonButton outline" href={signUpUrl}>Start Free Trial</a>
                            </div>
                        </div>
                    </Fade>
                </div>
            </section>
        </main>
    )
}
